import React, {useState} from "react"
import {useDisclosure} from "@heroui/react"
import {
  AlertsHeader,
  AlertsStats,
  AlertsList,
  FeatureUnavailableMessage,
} from "@/features/alerts"
import {StubIndicator} from "@/components/common/StubIndicator"
import SetAlertsDrawerMenu from "@/features/alerts/components/AlertSettingsMenu"

// Import stub hooks
import {
  USE_BI_ALERTS_STUB_DATA,
  useStubBIAlerts,
} from "@/utils/hooks/useStubBIAlerts"

function BIAlerts() {
  const [showAlerts, setShowAlerts] = useState<boolean>(true)
  const {
    isOpen: isSetAlertsDrawerOpen,
    onOpen: onSetAlertsDrawerOpen,
    onOpenChange: onSetAlertsDrawerOpenChange,
  } = useDisclosure()

  // Use stub data hook
  const {
    loading,
    data: allAlerts,
    unresolvedAlerts,
    resolvedAlerts,
  } = useStubBIAlerts()

  return (
    <div className="animate-fade animate-once animate-ease-linear mr-4 flex w-full flex-col gap-2 overflow-auto rounded-md border-black/5 bg-onyx-white p-4 transition-all duration-150">
      {/* Header with controls */}
      <AlertsHeader
        showAlerts={showAlerts}
        onAlertControlClick={onSetAlertsDrawerOpen}
        title="Business Intelligence Alerts"
      />

      {/* Indicator if using stub data */}
      {USE_BI_ALERTS_STUB_DATA && (
        <StubIndicator featureName="BI alerts" show={USE_BI_ALERTS_STUB_DATA} />
      )}

      {/* Feature unavailable message (only shown when feature is disabled) */}
      {!USE_BI_ALERTS_STUB_DATA && (
        <FeatureUnavailableMessage
          title="Business Intelligence Alerts"
          description="Gain insights and detect opportunities across your organization's communications. This feature will become available upon conversion to a paid trial."
        />
      )}

      {/* Stats cards - adapts based on feature availability */}
      <AlertsStats isStubEnabled={USE_BI_ALERTS_STUB_DATA} />

      {/* Alerts list - adapts based on feature availability */}
      <AlertsList
        isStubEnabled={USE_BI_ALERTS_STUB_DATA}
        unresolvedAlerts={unresolvedAlerts}
        resolvedAlerts={resolvedAlerts}
      />

      {/* Drawer menu for settings */}
      <SetAlertsDrawerMenu
        isOpen={isSetAlertsDrawerOpen}
        onOpenChange={onSetAlertsDrawerOpenChange}
        flag="bi"
      />
    </div>
  )
}

export default BIAlerts
